import { __assign, __extends, __makeTemplateObject, __rest } from "tslib";
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { noop } from 'lodash';
import { Icon } from '../Icon';
import { createComponent } from '../utils';
import { Field } from './Field';
import StyledLabel from './Label';
import { FormError, StyledFormError } from './FormError';
import { createEasyInput } from './EasyInput';
var InputContainer = createComponent({
    name: 'InputContainer',
    style: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n\n    & + ", " {\n      margin-left: 8px;\n    }\n  "], ["\n    position: relative;\n\n    & + ", " {\n      margin-left: 8px;\n    }\n  "])), StyledFormError),
});
var StyledInput = createComponent({
    name: 'Input',
    tag: 'input',
    style: function (_a) {
        var isFloatable = _a.isFloatable, isFloating = _a.isFloating, theme = _a.theme, _b = _a.borderRadius, borderRadius = _b === void 0 ? theme.radius : _b, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, leftIconProps = _a.leftIconProps, rightIconProps = _a.rightIconProps;
        return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    border: 1px solid ", ";\n    height: 48px;\n    display: block;\n    outline: none;\n    width: 100%;\n    padding: 8px;\n    padding-right: 24px;\n    border-radius: ", "px;\n    transition: 250ms all;\n    -webkit-appearance: none;\n    font-family: inherit;\n    font-size: ", "px;\n    color: ", ";\n    box-sizing: border-box;\n\n    &:hover,\n    &:active,\n    & + label &:hover {\n      border-color: ", ";\n    }\n\n    &:focus {\n      border-color: ", ";\n    }\n\n    ::placeholder {\n      color: ", ";\n      opacity: ", ";\n    }\n\n    &[disabled] {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      ::placeholder {\n        color: ", ";\n      }\n    }\n\n    ", ";\n\n    ", ";\n\n    ", ";\n  "], ["\n    border: 1px solid ", ";\n    height: 48px;\n    display: block;\n    outline: none;\n    width: 100%;\n    padding: 8px;\n    padding-right: 24px;\n    border-radius: ", "px;\n    transition: 250ms all;\n    -webkit-appearance: none;\n    font-family: inherit;\n    font-size: ", "px;\n    color: ", ";\n    box-sizing: border-box;\n\n    &:hover,\n    &:active,\n    & + label &:hover {\n      border-color: ", ";\n    }\n\n    &:focus {\n      border-color: ", ";\n    }\n\n    ::placeholder {\n      color: ", ";\n      opacity: ", ";\n    }\n\n    &[disabled] {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      ::placeholder {\n        color: ", ";\n      }\n    }\n\n    ",
            ";\n\n    ",
            ";\n\n    ",
            ";\n  "])), theme.colors.greyLight, borderRadius, theme.typography.fontSize, theme.typography.color, theme.colors.greyDark, theme.colors.primary, theme.colors.greyDarker, isFloatable ? 0 : 1, theme.colors.white, theme.colors.greyLight, theme.colors.grey, theme.colors.grey, leftIcon &&
            !isFloatable && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      padding-left: ", "px;\n    "], ["\n      padding-left: ", "px;\n    "])), (leftIconProps.size || 16) + 12), rightIcon && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding-right: ", "px;\n    "], ["\n      padding-right: ", "px;\n    "])), (rightIconProps.size || 16) + 32), isFloating && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      line-height: 16px;\n      padding-top: 16px;\n      padding-bottom: 0px;\n    "], ["\n      line-height: 16px;\n      padding-top: 16px;\n      padding-bottom: 0px;\n    "]))));
    },
});
var StyledIcon = styled(Icon)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme, isDisabled = _a.isDisabled;
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: 250ms all;\n\n    ", "\n  "], ["\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: 250ms all;\n\n    ",
        "\n  "])), isDisabled && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.colors.grey));
});
var LeftIcon = createComponent({
    name: 'InputLeftIcon',
    as: StyledIcon,
    style: function (_a) {
        var isFocused = _a.isFocused, isFloating = _a.isFloating, isFloatable = _a.isFloatable, theme = _a.theme;
        return css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    left: 8px;\n\n    ", "\n\n    ", "\n  "], ["\n    left: 8px;\n\n    ",
            "\n\n    ",
            "\n  "])), isFloatable && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      position: static;\n      padding-right: 4px;\n    "], ["\n      position: static;\n      padding-right: 4px;\n    "]))), isFloating && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      font-size: 12px;\n      line-height: 14px;\n\n      ", "\n    "], ["\n      font-size: 12px;\n      line-height: 14px;\n\n      ",
            "\n    "])), isFocused && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n        color: ", ";\n      "], ["\n        color: ", ";\n      "])), theme.colors.primary)));
    },
});
var RightIcon = createComponent({
    name: 'InputRightIcon',
    as: StyledIcon,
    style: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    right: 8px;\n  "], ["\n    right: 8px;\n  "]))),
});
var StyledTextArea = createComponent({
    name: 'TextArea',
    as: StyledInput.withComponent('textarea'),
    style: function (_a) {
        var isFloatable = _a.isFloatable, isFloating = _a.isFloating;
        return css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ",
            "\n  "])), isFloatable &&
            isFloating && css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      padding-top: 24px;\n    "], ["\n      padding-top: 24px;\n    "]))));
    },
});
var AutogrowShadow = createComponent({
    name: 'AutogrowShadow',
    tag: 'textarea',
    style: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    position: absolute;\n    left: -9999px;\n  "], ["\n    position: absolute;\n    left: -9999px;\n  "]))),
    props: function () { return ({
        tabIndex: -1,
    }); },
});
var InputClass = (function (_super) {
    __extends(InputClass, _super);
    function InputClass() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focused: false,
        };
        _this.inputRef = React.createRef();
        _this.onFocus = function (e) {
            _this.setState({ focused: true });
            _this.props.onFocus(e.target.name);
        };
        _this.onBlur = function (e) {
            _this.setState({ focused: false });
            var _a = _this.props, onBlur = _a.onBlur, onChange = _a.onChange, transformOnBlur = _a.transformOnBlur;
            onBlur(e.target.name);
            var currentValue = _this.props.value;
            if (transformOnBlur && currentValue) {
                var transformedValue = transformOnBlur(currentValue);
                if (transformedValue !== currentValue) {
                    onChange(e.target.name, transformedValue);
                }
            }
        };
        _this.onChange = function (e) {
            _this.setState({ value: e.target.value });
            _this.props.onChange(e.target.name, e.target.value, e);
        };
        _this.handleAutogrowRef = function (node) {
            _this.autogrowShadowNode = node;
            _this.autogrow();
        };
        _this.handleLabelClick = function () {
            if (_this.props.floating) {
                _this.focus();
            }
        };
        return _this;
    }
    InputClass.getDerivedStateFromProps = function (props, state) {
        if (props.value !== undefined && props.value !== state.value) {
            return {
                value: props.value,
            };
        }
        return null;
    };
    Object.defineProperty(InputClass.prototype, "ref", {
        get: function () {
            return this.props.forwardedRef || this.inputRef;
        },
        enumerable: false,
        configurable: true
    });
    InputClass.prototype.componentDidMount = function () {
        if (this.props.autoFocus && this.ref.current) {
            this.ref.current.focus();
        }
        if (this.props.multiline) {
            this.setState({
                height: (this.props.rows || 0) * (this.props.rowHeight || 0) * (this.props.lineHeight || 0),
            });
        }
    };
    InputClass.prototype.componentDidUpdate = function (_oldProps, oldState) {
        if (oldState.value !== this.state.value) {
            this.autogrow();
        }
    };
    InputClass.prototype.componentWillUnmount = function () {
        if (this.autogrowShadowNode && this.autogrowShadowNode.parentNode) {
            this.autogrowShadowNode.parentNode.removeChild(this.autogrowShadowNode);
        }
    };
    InputClass.prototype.autogrow = function () {
        if (!this.props.autogrow || !this.autogrowShadowNode) {
            return;
        }
        var _a = this.props, _b = _a.minRows, minRows = _b === void 0 ? 0 : _b, _c = _a.maxRows, maxRows = _c === void 0 ? 0 : _c, _d = _a.rowHeight, rowHeight = _d === void 0 ? 0 : _d, _e = _a.lineHeight, lineHeight = _e === void 0 ? 0 : _e;
        var minHeight = minRows * rowHeight * lineHeight;
        var maxHeight = maxRows * rowHeight * lineHeight;
        this.autogrowShadowNode.style.width = this.ref.current.clientWidth + "px";
        this.autogrowShadowNode.value = this.state.value;
        var height = this.autogrowShadowNode.scrollHeight + rowHeight * lineHeight;
        if (height < minHeight) {
            height = minHeight;
        }
        else if (height > maxHeight) {
            height = maxHeight;
        }
        this.setState({ height: height });
    };
    InputClass.prototype.focus = function () {
        this.ref.current.focus();
    };
    InputClass.prototype.blur = function () {
        this.ref.current.blur();
    };
    InputClass.prototype.render = function () {
        var _a = this.props, style = _a.style, minRows = _a.minRows, maxRows = _a.maxRows, rowHeight = _a.rowHeight, label = _a.label, multiline = _a.multiline, autogrow = _a.autogrow, autoFocus = _a.autoFocus, id = _a.id, error = _a.error, floating = _a.floating, placeholder = _a.placeholder, transformOnBlur = _a.transformOnBlur, size = _a.size, leftIcon = _a.leftIcon, leftIconProps = _a.leftIconProps, rightIcon = _a.rightIcon, rightIconProps = _a.rightIconProps, disabled = _a.disabled, rest = __rest(_a, ["style", "minRows", "maxRows", "rowHeight", "label", "multiline", "autogrow", "autoFocus", "id", "error", "floating", "placeholder", "transformOnBlur", "size", "leftIcon", "leftIconProps", "rightIcon", "rightIconProps", "disabled"]);
        var _b = this.state, focused = _b.focused, height = _b.height, value = _b.value;
        var isFloating = (floating && value != null && !!("" + value).trim()) || (floating && focused);
        var inputProps = __assign(__assign({}, rest), { id: id, ref: this.ref, size: size,
            value: value, onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur, style: multiline ? __assign(__assign({}, style), { height: height }) : style, placeholder: placeholder, isFloatable: floating, isFloating: isFloating,
            error: error,
            leftIcon: leftIcon,
            leftIconProps: leftIconProps,
            rightIcon: rightIcon,
            rightIconProps: rightIconProps,
            disabled: disabled });
        var styles = rest.styles;
        var statusProps = {
            isFloatable: floating,
            isFloating: isFloating,
            isFocused: focused,
            isDisabled: disabled,
        };
        var Label = label ? (React.createElement(StyledLabel, __assign({ htmlFor: id, styles: styles, error: error, multiline: multiline, onClick: this.handleLabelClick }, statusProps),
            leftIcon && React.createElement(LeftIcon, __assign({ styles: styles, name: leftIcon }, statusProps, leftIconProps)),
            label)) : null;
        return (React.createElement(Field, { styles: styles },
            !floating && Label,
            React.createElement(InputContainer, { styles: styles },
                floating && Label,
                leftIcon && !floating && React.createElement(LeftIcon, __assign({ styles: styles, name: leftIcon }, statusProps, leftIconProps)),
                rightIcon && React.createElement(RightIcon, __assign({ styles: styles, name: rightIcon, size: 24 }, statusProps, rightIconProps)),
                multiline ? React.createElement(StyledTextArea, __assign({}, inputProps)) : React.createElement(StyledInput, __assign({}, inputProps))),
            !focused && error ? React.createElement(FormError, null, error) : null,
            autogrow && React.createElement(AutogrowShadow, { ref: this.handleAutogrowRef })));
    };
    InputClass.defaultProps = {
        type: 'text',
        multiline: false,
        minRows: 2,
        rows: 3,
        maxRows: 6,
        rowHeight: 14,
        lineHeight: 1.5,
        autogrow: false,
        disabled: false,
        size: 'md',
        onFocus: noop,
        onBlur: noop,
        onChange: noop,
        floating: false,
        leftIconProps: {},
        rightIconProps: {},
    };
    return InputClass;
}(Component));
export { InputClass };
export var Input = createEasyInput(InputClass);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;
//# sourceMappingURL=Input.js.map